module.exports = __webpack_public_path__ + "img/9788960510029.01864a01.jpg";